import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';
import { map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable()
export class EffectsRouter {
  pageTitle$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATED),
      map((action: any) => action.payload),
      tap(({ routerState }) => {
        const route = this.getCurrentRoute(routerState);
      })
    )
  }, { dispatch: false });

  constructor(private readonly actions$: Actions, private readonly titleService: Title) { }

  private getCurrentRoute(routerState) {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    return route;
  }
}
